<template>
    <el-dialog title="时间节点设置"
               :close-on-click-modal="false"
               :visible.sync="dialogActivityDateVisible"
               append-to-body class="dialogActivityDateVisible">
        <el-form :model="activityDateData" :rules="rulesSuccess" ref="ruleForm">
            <el-form-item label="节点名称"  prop="name">
                <el-input v-model="activityDateData.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="时间类型"  prop="nodeDateType">
                <el-radio-group v-model="activityDateData.dateType" @change="clearDateInfo">
                    <el-radio label="DATE" key="0" value="DATE">时间点</el-radio>
                    <el-radio label="RANGE" key="1" value="RANGE">时间段</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="时间" prop="startDate1" ref="startDate1" v-if="activityDateData.dateType==='DATE'">
                <!-- <el-date-picker
                    key="1"
                    v-model="activityDateData.startDate1"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker> -->
                <el-date-picker
                    key="1"
                    v-model="startDate1"
                    @change= "startDateMess"
                    type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="时间" prop="quantumDate" ref="quantumDate" v-if="activityDateData.dateType==='RANGE'">
                <el-date-picker
                    key="2"
                    v-model="quantumDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item prop="status" label="节点状态">
                <el-select v-model="activityDateData.status" clearable placeholder="请选择">
                    <el-option key="0" label="准备中" value="PREPARE"></el-option>
                    <el-option key="1" label="征集中" value="COLLECT"></el-option>
                    <el-option key="2" label="评选中" value="EVALUATE"></el-option>
                    <el-option key="3" label="已结束" value="FINISHED"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="sort" label="排序">
                <el-input-number v-model="activityDateData.sort"  :min="1"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogActivityDateVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitActivityDateInfo(0)">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "activityDate",
    data() {
        return {
            dialogActivityDateVisible:false,
            quantumDate:[],
            startDate1: '',
            activityDateData: {
                name: '',
                dateType: 'DATE',
                //quantumDate1:[],
                startDate: '',
                startDate1: '',
                endDate: '',
                sort:1,
                updateIndex:'',
                status:'',
            },
            rulesSuccess:{
                name:[
                    {required: true, message: '请输入节点名称', trigger: 'blur'}
                ],
                startDate1:[
                    {required: true, message: '请选择时间', trigger: 'change'}
                ],
                /*quantumDate:[
                    {required: true, message: '请选择时间', trigger: 'change'}
                ],*/
                status:[
                    {required: true, message: '请选择节点状态', trigger: 'change'}
                ],
            },
            nodeList:[],
        }
    },
    created(){

    },
    methods: {
        init(item,list){
            this.reset();
            this.nodeList = list;
            if(item!==undefined&&item!==null){
                this.activityDateData = item;
                this.quantumDate = [];
                if(this.activityDateData.dateType==='RANGE'){
                    this.quantumDate.push(new Date(this.activityDateData.startDate));
                    this.quantumDate.push(new Date(this.activityDateData.endDate));
                }else if(this.activityDateData.dateType==='DATE'){
                    this.activityDateData.startDate1 = new Date(this.activityDateData.startDate);
                    this.startDate1 = new Date(this.activityDateData.startDate);
                }
            }
            this.dialogActivityDateVisible = true;
        },
        startDateMess(){
            this.activityDateData.startDate1 = this.startDate1
        },
        reset(){
            this.startDate1 = "";
            // 置空
            this.activityDateData = {
                name: '',
                dateType: 'DATE',
                //quantumDate1:[],
                startDate: '',
                startDate1: '',
                endDate: '',
                sort:1,
                updateIndex:'',
                status:'',
            };
            this.$nextTick(() => {
                // DOM 更新了
                this.$refs["ruleForm"].clearValidate()
            });
        },
        clearDateInfo(){
            this.startDate1 = '';
            this.activityDateData.startDate1 = '';
            this.activityDateData.endDate = '';
            this.quantumDate = [];
        },
        submitActivityDateInfo(index){
            if(index==1){
                // 右上角关闭，手动ESC
                if(this.activityDateData.dateType!=='DATE'){
                    // if (this.activityDateData.startDate1 !== "") {
                    if (this.startDate1 !== "") {
                        // this.activityDateData.startDate = this.timeDate(this.activityDateData.startDate1);
                        this.activityDateData.startDate = this.timeDate(this.startDate1);
                    }
                }
                if (this.activityDateData.dateType === 'RANGE') {
                    if (this.quantumDate.length == 2) {
                        this.activityDateData.startDate = this.timeDate(this.quantumDate[0]);
                        this.activityDateData.endDate = this.timeDate(this.quantumDate[1]);
                    }
                }
            }else if(index===0){
                if (this.activityDateData.dateType === 'DATE') {
                    // if (this.activityDateData.startDate1 === "") {
                    if (this.startDate1 === "") {
                        this.$message.error("请选择时间");
                        return;
                    } else {
                        // this.activityDateData.startDate = this.timeDate(this.activityDateData.startDate1);
                        this.activityDateData.startDate = this.timeDate(this.startDate1);
                    }
                }
                if (this.activityDateData.dateType === 'RANGE') {
                    if (this.quantumDate.length == 2) {
                        this.activityDateData.startDate = this.timeDate(this.quantumDate[0]);
                        this.activityDateData.endDate = this.timeDate(this.quantumDate[1]);
                    } else {
                        this.$message.error("请选择时间");
                        return;
                    }
                }
                // if (this.activityDateData.startDate1 !== "") {
                if (this.startDate1 !== "") {
                    // if (new Date(this.activityDateData.startDate1).getTime() < new Date().getTime()) {
                    if (new Date(this.startDate1).getTime() < new Date().getTime()) {
                        this.$message.error("开始时间要大于当前时间,请修改");
                        return false;
                    }
                }
                // 判断该节点是否存在
                if(this.nodeList!=null&&this.nodeList.length>0){
                   for(let i=0;i<this.nodeList.length;i++){
                        // 新增没有出现下标，所以是空的
                        if(typeof this.activityDateData.updateIndex!=='number'){
                            if(this.activityDateData.status!=="EVALUATE"
                                &&this.nodeList[i].status===this.activityDateData.status){
                                this.$message.error("该节点已经存在,无法重复添加");
                                return false;
                            }
                        }else{
                            // 编辑出现下标，需要判断是否为当前下标
                            if(i!=this.activityDateData.updateIndex){
                                if(this.activityDateData.status!=="EVALUATE"
                                    &&this.nodeList[i].status===this.activityDateData.status){
                                    this.$message.error("该节点已经存在,无法重复添加");
                                    return false;
                                }
                            }
                        }
                   }
                }
            }
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    this.dialogActivityDateVisible = false;
                    this.$emit("submit",this.activityDateData);
                }
            });
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
    },
}
</script>

<style  scoped lang="less">
.imgsMess {
    margin: 0;
    margin-left: 10px;
    color: #a1a1a1;
}
.thumbnailClass{
    width: 222px;
    //height: 125px;
    .avatar{
        width: 222px;
        height: 125px;
        border: 1px dashed #ddd;
        border-radius: 4px;
        line-height: 125px;
        font-size: 50px;
    }
}
.modelHeightRangeClass{
    display: flex;
    margin-bottom: 25px;
    /deep/.el-form-item__content{
        margin-left: 0 !important;
    }
}
.dialogActivityDateVisible {
    /deeep/.el-dialog__body {
        padding-left: 30px !important;
        padding-right: 30px !important;
    }
}
.awaedUrlImgs {
    /deep/.el-image {
        width: 125px;
        height: 154px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/activityDateDialog.vue